var serializedKeys = ['id', 'sort', 'by', 'page', 'itemsPerPage', 'mode', 'lastLoadingTook'];

var get = function get(id) {
  var view = localStorage.getItem('ECR.EOS.Grids.' + id);
  if (!view) return null;
  return JSON.parse(view);
};

var save = function save(id, view) {
  var storedView = {};
  serializedKeys.map(function (key) {
    return storedView[key] = view[key];
  });
  return localStorage.setItem('ECR.EOS.Grids.' + id, JSON.stringify(storedView));
};

export default {
  get: get,
  save: save
};